// extracted by mini-css-extract-plugin
module.exports = {"percent":"styles_percent__2YbrD","values":"styles_values__1IJdL"};